
import React from "react";
import { Box } from "@mui/material";

import Header from "./components/header";
import HeroSection from "./components/HeroSection";
import AboutSection from "./components/AboutSection";
import HowItWorks from "./components/HowItWorks";
import ContactSection from "./components/ContactSection";
import Footer from "./components/footer";

const HomeScreen: React.FC = () => {
  return (
    <Box
    
      dir="ltr"
      sx={{
        overflowX: "hidden",
        direction: "ltr" // force LTR
      }}>
      <Header />

      <Box
        sx={{
          maxWidth: "1600px",
          width: "100%",
          margin: "0 auto"
        }}
      >
        <HeroSection />
        <AboutSection />
        <HowItWorks />
        <ContactSection />
        <Footer/>
      </Box>
    </Box>
  );
};

export default HomeScreen;